module.exports = __webpack_public_path__ + "img/icon-edit.f663f387.svg";